<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="col-md-4 col-lg-3">
      <nav class="left-nav">
        <h4 class="mb-2">Statement Categories</h4>
        <div class="items">
          <button
            v-for="category in categories"
            :key="category.id"
            class="btn w-100 text-start"
            :class="[
              selectedCategory?.id === category.id
                ? 'btn-primary'
                : 'btn-simple',
            ]"
            @click="selectCategory(category)"
            draggable="true"
            @dragstart="handleDragStart(category, $event)"
            @dragover="handleDragOver(category, $event)"
            @drop="handleDrop(category, $event)"
          >
            <span class="drag-handle" style="cursor: move; margin-right: 5px;">⋮⋮</span>
            {{ category.name }}
          </button>
          <button
            class="btn w-100 text-start"
            :class="[!selectedCategory?.id ? 'btn-primary' : 'btn-simple']"
            @click="newCategory"
          >
            + New Category
          </button>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-9">
      <div v-if="selectedCategory">
        <div class="card p-4">
          <h4 class="mb-4">
            {{ selectedCategory.id ? "Edit Category" : "New Category" }}
          </h4>

          <div class="mb-3">
            <label class="form-label">Category Name</label>
            <input
              type="text"
              class="form-control"
              v-model="selectedCategory.name"
            />
          </div>

          <div class="mb-3">
            <label class="form-label">Pair Webshops (Sale channels)</label>
            <multiselect
              v-model="selectedCategory.webshop_ids"
              :options="webshops"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :hide-selected="true"
              :placeholder="'Select webshops'"
              label="name"
              track-by="id"
            ></multiselect>
          </div>

          <div class="mb-3">
            <label class="form-label">Integration Pages</label>
            <multiselect
              v-model="selectedCategory.integration_page_ids"
              :options="integrationPages"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :hide-selected="true"
              :placeholder="'Select integration pages'"
              label="name"
              track-by="id"
            ></multiselect>
          </div>

          <div class="d-flex gap-2">
            <button class="btn btn-primary" @click="saveCategory">Save Category</button>
            <button class="btn btn-danger" @click="deleteCategory">Delete Category</button>
          </div>
        </div>
      </div>
      <div v-else>
        <h4>Income Statement Settings</h4>
        <p>Select a category to edit its details or add a new category.</p>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";

export default {
  name: "IncomeStatementSettings",
  data() {
    return {
      categories: [],
      webshops: [],
      integrationPages: [],
      selectedCategory: null,
      draggedCategory: null,
    };
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    loadInitialData() {
      http.fetch("/income-statement/categories").then((data) => {
        this.categories = data.data;
      });
      http.fetch("/webshops").then((data) => {
        this.webshops = data;
      });
      http.fetch("/service-integrations/pages").then((data) => {
        this.integrationPages = data.data;
      });
    },
    selectCategory(category) {
      this.selectedCategory = {
        ...category,
        webshop_ids: category.webshops?.map((w) => w.id),

        integration_page_ids: category.integrationPages?.map((p) => p.id),
      };
    },
    newCategory() {
      this.selectedCategory = {
        name: "",
        webshop_ids: [],
        integration_page_ids: [],
      };
    },
    saveCategory() {
      const url = this.selectedCategory.id
        ? `/income-statement/categories/${this.selectedCategory.id}`
        : "/income-statement/categories";
      const method = this.selectedCategory.id ? "PUT" : "POST";

      http.fetch(url, this.selectedCategory, true, method).then(() => {
        this.loadInitialData();
        this.selectedCategory = null;
      });
    },
    deleteCategory() {
      if (confirm("Are you sure you want to delete this category?")) {
        http
          .fetch(
            `/income-statement/categories/${this.selectedCategory.id}`,
            null,
            true,
            "DELETE"
          )
          .then(() => {
            this.loadInitialData();
            this.selectedCategory = null;
          });
      }
    },
    handleDragStart(category, event) {
      this.draggedCategory = category;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', category.id);
    },
    handleDragOver(category, event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
    },
    handleDrop(category, event) {
      event.preventDefault();
      
      if (this.draggedCategory && this.draggedCategory.id !== category.id) {
        // Reorder categories
        const draggedIndex = this.categories.findIndex(c => c.id === this.draggedCategory.id);
        const targetIndex = this.categories.findIndex(c => c.id === category.id);
        
        if (draggedIndex !== -1 && targetIndex !== -1) {
          // Remove dragged item
          const [removed] = this.categories.splice(draggedIndex, 1);
          // Insert at new position
          this.categories.splice(targetIndex, 0, removed);
          
          // Update all category orders
          this.updateCategoriesOrder();
        }
      }
      
      this.draggedCategory = null;
    },
    updateCategoriesOrder() {
      // Update each category's order in the database
      const updatePromises = this.categories.map((category, index) => {
        return http.fetch(
          `/income-statement/categories/${category.id}/order`,
          { order: index },
          true,
          'PUT'
        );
      });
      
      // Wait for all updates to complete
      Promise.all(updatePromises)
        .then(() => {
          // Successfully updated all orders
          console.log('Category orders updated successfully');
        })
        .catch(error => {
          console.error('Failed to update category orders:', error);
        });
    }
  },
};
</script>

<style scoped>
.left-nav .items .btn {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.left-nav .items .btn .drag-handle {
  margin-right: 8px;
  opacity: 0.5;
}
</style>
